import React from 'react'
import ResumenItem from '../elements/ResumenItem'

const ResumeSection = () => {
  return (
    <section id="resume" className="resume section">

      <div className="container section-title" data-aos="fade-up">
        <h2>Experiencia</h2>
        <p>
          Contamos con experiencia con diferentes clientes y proyectos, con trabajos independientes y para empresas.
        </p>
      </div>

      <div className="container">

        <div className="row">

          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <h3 className="resume-title">Proyectos freelance</h3>
            <ResumenItem
              speciality="Aplicación web para consultorio de psicólogos"
              year="2021"
              place="Digital Product Manager, Región de la Araucanía, Temuco"
              works={[
                "Manejo de fichas médicas",
                "Pasarela de pago",
                "Gestión de agenda de citas"
              ]}
            ></ResumenItem>

            <ResumenItem
              speciality="Administración de aforo institucional"
              year="2021"
              place="Universidad Santo Tomás, Región de Coquimbo, La Serena"
              works={[
                "Administración de entradas y salidas de alumnos y profesores",
                "Comprobación de acceso mediante código QR y tarjeta de identificación",
                "Automatización de procesos de inscripciones"
              ]}
            ></ResumenItem>

            <ResumenItem
              speciality="Aplicación web para control de inventario"
              year="2022"
              place="Bambino, Región de Coquimbo, Vicuña"
              works={[
                "Desarrollo de aplicación web para el control de inventario",
                "Gestión y control de usuarios",
              ]}
            ></ResumenItem>
          </div>

          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
            <h3 className="resume-title">Trabajo para empresas</h3>
            <ResumenItem
              speciality="Sistema de ERP facturacion.cl"
              year="2022"
              place="Desis, Región Metropolitana, Santiago"
              works={[
                "Análisis y desarrollo de requerimientos",
                "Documentación de requerimientos",
              ]}
            ></ResumenItem>

            <ResumenItem
              speciality="Aplicación web para control de aforo de vehículos"
              year="2022"
              place="Minera Teck Carmen de Andacollo, Región de Coquimbo, Andacollo"
              works={[
                "Mantenimiento de sistemas de información",
                "Desarrollo de aplicación web para el control de aforo de vehículos",
              ]}
            ></ResumenItem>
          </div>


        </div>

      </div>

    </section>
  )
}

export default ResumeSection